{
  "name": "scumm-nes",
  "version": "0.2.2",
  "description": "An app to explore and modify the game Maniac Mansion on NES.",
  "author": "edo999@gmail.com",
  "license": "BlueOak-1.0.0",
  "keywords": [
    "video game",
    "adventure game",
    "scumm",
    "hacks"
  ],
  "homepage": "https://gmarty.github.io/scumm-nes",
  "repository": "git+https://github.com/gmarty/scumm-nes.git",
  "bugs": {
    "url": "https://github.com/gmarty/scumm-nes/issues"
  },
  "type": "module",
  "source": "src/index.html",
  "staticFiles": {
    "staticPath": "public"
  },
  "bin": {
    "scumm-nes": "index.js"
  },
  "engines": {
    "node": ">=20"
  },
  "scripts": {
    "test": "node --test",
    "coverage": "node --experimental-test-coverage --test",
    "dev": "rm -rf dist .parcel-cache && parcel",
    "start": "rm -rf dist .parcel-cache && parcel",
    "build": "parcel build --public-url /scumm-nes"
  },
  "dependencies": {
    "@headlessui/react": "^2.2.0",
    "@heroicons/react": "^2.1.5",
    "clsx": "^2.1.1",
    "react": "^18.3.1",
    "react-dom": "^18.3.1",
    "react-dropzone": "^14.3.5",
    "react-error-boundary": "^4.1.2",
    "react-router-dom": "^6.28.0"
  },
  "devDependencies": {
    "@babel/plugin-proposal-private-property-in-object": "^7.21.11",
    "@tailwindcss/forms": "^0.5.9",
    "autoprefixer": "^10.4.20",
    "eslint": "^8.57.1",
    "eslint-config-react-app": "^7.0.1",
    "parcel": "^2.13.0",
    "parcel-reporter-static-files-copy": "^1.5.3",
    "postcss": "^8.4.49",
    "prettier": "^3.3.3",
    "prettier-plugin-tailwindcss": "^0.6.8",
    "process": "^0.11.10",
    "tailwindcss": "^3.4.14"
  },
  "optionalDependencies": {
    "@parcel/watcher-linux-x64-glibc": "^2.5.0"
  },
  "prettier": {
    "bracketSameLine": true,
    "singleQuote": true,
    "singleAttributePerLine": true,
    "plugins": [
      "prettier-plugin-tailwindcss"
    ]
  },
  "browserslist": "last 2 Chrome versions, last 2 Firefox versions, Firefox ESR, last 1 Safari versions"
}
